export enum CellDataSourceType {
	Asset = 'asset',
	AssetGroup = 'assetGroup',
	Cost = 'cost',
	Incident = 'incident',
	Kpi = 'kpi',
	Metric = 'metric',
	None = 'none',
	Service = 'service',
	Sla = 'sla',
}
